/**
 * en-GB messages added by Phase 4 task C8 (docs/PHASE-4-PLAN.md). Only that task edits this file.
 * Flat keys, `{name}` placeholders, merged into enGB by ./index.ts.
 */
export const c8EnGB = {
    // Refusals returned by the domain routes.
    'error.domain_reserved': 'That address is reserved. You can only use your own name under the CloudSign domain, or a domain you own.',
    'error.domain_in_use': 'That address is already in use.',
    'error.domain_limit': 'You have reached the number of custom domains your account allows.',
    'error.domain_not_verified': 'This domain has not been verified yet.',
    'error.domain_disabled_by_platform': 'This domain was switched off by CloudSign. Please contact support.',
    // Why a check did not pass (shown next to the domain, and stored on it).
    'domain.error.txt_missing': 'The verification (TXT) record was not found yet. DNS changes can take a while to spread.',
    'domain.error.cname_missing': 'The address does not point at CloudSign yet. Add the CNAME record shown.',
    'domain.error.dns_unavailable': 'We could not look up your DNS records just now. We will try again shortly.',
    'domain.error.txt_lost': 'The verification (TXT) record has been missing for 3 days, so the domain was switched off.',
    'domain.error.timed_out': 'The records were not found within 7 days. Check them, then ask for a new check.',
    'domain.error.disabled_by_platform': 'Switched off by CloudSign.',
    // Email to the people who manage the account when a domain is switched off.
    'domain.email.disabled.subject': 'Your domain {hostname} has been switched off',
    'domain.email.disabled.body': 'The domain {hostname} has been switched off because its verification record is no longer in your DNS. Add the TXT record again in your DNS settings, then open Settings, Domains and choose Check now.',
    // Footer link in emails when people can send a data request.
    'email.your_data': 'Your data',
    'email.your_data_text': 'Your data: {url}',
};
//# sourceMappingURL=c8.js.map